/* istanbul ignore file */
import Vue from "vue";
import StoreFacet_Wrapper from "./StoreFacet_Wrapper.vue";
import StoreFacet_Item from "./StoreFacet_Item.vue";

const vueElQuery = "[data-vue-app='show_more_facets']";
const vueView = "[data-vue-view]";

document.ready.then(() => {
  const isVueView = document.querySelectorAll(vueView).length > 0;
  if (!isVueView) {
    for (let vueEl of document.querySelectorAll(vueElQuery)) {
      new Vue({
        el: vueEl,
        components: {
          "store-facet-wrapper": StoreFacet_Wrapper,
          "store-facet-item": StoreFacet_Item,
        },
      });
    }
  }
});
